
/* Componente bottone che inverte il punto di partenza con il punto di arrivo */ 

import React, { Component } from 'react';
import IconButton from '@material-ui/core/IconButton';
import SwapVerticalCircleIcon from '@material-ui/icons/SwapVerticalCircle';
import '../InvertiButton/SwapIcon.css'

export default class InvertiButton extends Component {
    constructor(props){
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick(){
        this.props.callback()
        
    }
    render(){
        return (
            <div className="swapIcon">
                <IconButton onClick={() => this.handleClick()}>
                <SwapVerticalCircleIcon size="large" />
                </IconButton>
            </div>
        )
    }

}